import { render, staticRenderFns } from "./Master.vue?vue&type=template&id=04f59085&"
import script from "./Master.vue?vue&type=script&lang=ts&"
export * from "./Master.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports